export abstract class GraphInclusiveRoutes {
    static Attendance = 'attendance';
    static Progress = 'progress';
    static OwnProgress = 'own-progress';
}
